import React from "react";
import Hero from "../components/home/Hero";
import AboutSection from "../components/home/AboutSection";
import ScrollyTelling from "../components/home/ScrollyTelling";
import ServicesSection from "../components/home/ServiceSection";
import StatsSection from "../components/home/StatsSection";
// import OurVisionSection from "../components/home/OurVisionSection";
import ApproachSection from "../components/home/ApproachSection";
import ClientTestimonials from "../components/home/ClientTestimonials";
import ContactSection from "../components/home/ContactSection";

const HomePage = () => {
  return (
    <div>
      <Hero />
      <ServicesSection />
      <ScrollyTelling />
      <StatsSection />
      <AboutSection />
      {/* <OurVisionSection /> */}
      <ApproachSection />
      <ClientTestimonials />
      <ContactSection />
    </div>
  );
};

export default HomePage;
